import { makeStyles } from "@material-ui/core/styles";
import React from "react";

const useStyles = makeStyles(() => ({
  tag: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: 24,
    padding: "5px 11px",
    borderRadius: 999,
    fontSize: "0.67rem",
    lineHeight: 1,
    fontWeight: 800,
    textTransform: "uppercase",
    whiteSpace: "nowrap"
  }
}));

const normalizeHex = (value, fallback) => {
  if (!value || typeof value !== "string") return fallback;
  const candidate = value.trim();
  if (/^#[0-9a-fA-F]{6}$/.test(candidate)) return candidate;
  if (/^#[0-9a-fA-F]{3}$/.test(candidate)) {
    return "#" + candidate.slice(1).split("").map((c) => c + c).join("");
  }
  return fallback;
};

const pastelStyle = (hex) => {
  const color = normalizeHex(hex, "#7c7c7c");
  const raw = color.replace("#", "");
  const r = parseInt(raw.substring(0, 2), 16);
  const g = parseInt(raw.substring(2, 4), 16);
  const b = parseInt(raw.substring(4, 6), 16);
  const luminance = (r * 299 + g * 587 + b * 114) / 1000;
  const textColor = luminance > 205
    ? `rgb(${Math.max(r - 115, 35)}, ${Math.max(g - 115, 35)}, ${Math.max(b - 115, 35)})`
    : color;

  return {
    backgroundColor: `rgba(${r}, ${g}, ${b}, 0.14)`,
    color: textColor,
    border: `1px solid rgba(${r}, ${g}, ${b}, 0.10)`
  };
};

const ContactTag = ({ tag }) => {
  const classes = useStyles();

  return (
    <div className={classes.tag} style={pastelStyle(tag?.color)}>
      {tag.name.toUpperCase()}
    </div>
  );
};

export default ContactTag;
